import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import routes from "routes";
import routesSolicitante from "routesSolicitante";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import logo from "assets/images/LOGO-Icontec-2019_hor_white.png";
import EvidenciaJuridica from "layouts/tables/AnexosJuridica";
import Cookies from "universal-cookie";

export default function App() {
  const cookie = new Cookies();

  // === CONTROLLER ===
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, openConfigurator, darkMode } = controller;

  const { pathname } = useLocation();
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  // === ESTADO DEL TIPO DE USUARIO ===
  const [tipoUsuario, setTipoUsuario] = useState(cookie.get("tipo_Usuario"));

  // === DETECTAR CAMBIOS DE COOKIE ===
  useEffect(() => {
    const interval = setInterval(() => {
      const nuevoTipo = cookie.get("tipo_Usuario");

      if (nuevoTipo && nuevoTipo !== tipoUsuario) {
        setTipoUsuario(nuevoTipo);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [tipoUsuario]);

  // === DIRECCIÓN ===
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // === SCROLL TO TOP ===
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // === LÓGICA SIDENAV ===
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // === MENÚ SEGÚN TIPO DE USUARIO ===
  const menuToRender = tipoUsuario == "2" ? routesSolicitante : routes;

  // === GENERAR RUTAS ===
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) return getRoutes(route.collapse);

      if (route.route)
        return (
          <Route
            key={route.key}
            path={route.route}
            element={route.component} // COMPONENTE DEBE SER JSX: <Componente />
          />
        );

      return null;
    });

  // === BOTÓN CONFIGURADOR ===
  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  // === RENDER ===
  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />

      {layout === "dashboard" && (
        <>
          <Sidenav
            brand={logo}
            routes={menuToRender}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />

          <Configurator />
          {configsButton}
        </>
      )}

      {layout === "vr" && <Configurator />}

      <Routes>
        {/* Redirección inicial */}
        <Route path="/" element={<Navigate to="/authentication/sign-in" />} />

        {/* Rutas dinámicas según tipo de usuario */}
        {getRoutes(menuToRender)}

        {/* Ruta especial */}
        <Route path="/AnexoJuridica/:id" element={<EvidenciaJuridica />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
      </Routes>
    </ThemeProvider>
  );
}
